<template lang="pug">
  div.content.d-flex.justify-content-center(v-if="['logout', 'direct', 'session', 'manager'].includes(code)" :class="{ 'is-mobile': isMobile }")
    .show-wait
      .sec
        img(src="@/assets/loading_img.png")
        .msg(v-if="!isMobile")
          span(v-if="code === 'logout'") {{$t('error_page.logout_completed')}}
          span(v-else-if="code === 'direct'") {{$t('error_page.invalid_access')}}
          span(v-else-if="code === 'manager'" v-html="$t('error_page.manager_registration_required')" )
        .msg(v-else)
          span(v-if="code === 'logout'") {{$t('error_page.logout_completed')}}
          span(v-else-if="code === 'direct'" v-html="$t('error_page.invalid_access_vpn')" )
          span(v-else-if="code === 'session'") {{$t('error_page.session_expired')}}
          span(v-else-if="code === 'manager'" v-html="$t('error_page.manager_registration_success')" )
  div.error(v-else)
    div.error-header
      div.logo
        img(src="@/assets/logo_big.png")
      h1 {{code}}
    div.error-body
      b-btn(variant="link", :href="referrer") {{referrer}}
</template>

<script>
import store from '@/api/store'

export default {
  name: "file-not-found",
  props: {
    code: {
      type: [Number, String],
      required: true,
    },
    referrer: {
      type: String,
      default: document.referrer,
    },
  },
  computed: {
    isMobile() {
      if (this.AppState.isApplication) return true
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  mounted() {
    if (this.code === 'logout') {
      const expire = new Date()
      store.set("lmm_autologin", 'NO', expire.getTime())
      if (window.LMM_MOBILE_SEND) {
        window.LMM_MOBILE_SEND("WEB_CHECK:CHANGED:" + 'NO')
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./error.scss"></style>